import { render, staticRenderFns } from "./CompanyNotPaid.vue?vue&type=template&id=10c921b9&"
var script = {}
import style0 from "./CompanyNotPaid.vue?vue&type=style&index=0&id=10c921b9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports